<template lang="html">
	<div>
		<b-form-group label="Логин:">
			<b-form-input v-model="$v.user.uid.$model" :disabled="noValidate" placeholder="Введите логин" :state="validateUid()" autocomplete="off"></b-form-input>
			<b-form-invalid-feedback v-if="!$v.user.uid.uidCheck">Такой пользователь уже существует</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.uid.required">Поля обязательно для заполнения</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.uid.checkUidRegex1">Логин может содержать только латинские буквы, цифры и символы _ - .</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.uid.checkUidRegex2">Логин должен начинаться на букву</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.uid.checkUidRegex3">Логин должен заканчиваться буквой или цифрой</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.uid.checkUidRegex4">Логин должен быть от 6 до 20 символов</b-form-invalid-feedback>
			<b-form-invalid-feedback v-if="!$v.user.uid.esiaCheck">Префикс <b>Esia</b> запрещен</b-form-invalid-feedback>			
			<b-form-group v-if="errors.length > 0">
				<div class="error" v-for="(error, index) in errors" :key="index">{{ error }}</div>
			</b-form-group>
		</b-form-group>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { CHECK_UID } from '@/store/actions.type'
import { required, helpers } from 'vuelidate/lib/validators'

var uidRegex1 = /^[A-Za-z\d._-]+$/
var uidRegex2 = /^[A-Za-z]/
var uidRegex3 = /^(?=.*[A-Za-z0-9]$)/
var uidRegex4 = /^(.{6,20})/
const checkUidRegex1 = helpers.regex('checkUidRegex1', uidRegex1)
const checkUidRegex2 = helpers.regex('checkUidRegex2', uidRegex2)
const checkUidRegex3 = helpers.regex('checkUidRegex3', uidRegex3)
const checkUidRegex4 = helpers.regex('checkUidRegex4', uidRegex4)

export default {
	name: 'BaseEmail',
	props: {
		user: {
			type: Object,
		},
		noValidate: {
			type: Boolean,
			default: false
		}
	},
	validations: {
		user: {
			uid: {
				required,
				checkUidRegex1,
				checkUidRegex2,
				checkUidRegex3,
				checkUidRegex4,
				esiaCheck(value) {
					return value.toLowerCase().indexOf("esia") !== 0
				},
				uidCheck(value) {
					if (this.noValidate) {
						return true
					}
					
					if (value === this.uid.name) {
						return !this.uid.exist
					}
					else {
						return new Promise((resolve, reject) => {
							this.checkUid().then(x => {
								resolve(!this.uid.exist)
							})
						})
					}
				}
			}
		}
	},
	computed: {
		...mapGetters({
			isLoading: 'checkUidIsLoading',
			errors: 'checkUidErrors'
		})
	},
	data() {
		return {
			uid: {
				name: '',
				exist: false,
			},
			delayTimer: ''
		}
	},
	methods: {
		checkUid () {
			return new Promise((resolve, reject) => {
				this.user.name = this.user.uid
				if (this.$v.user.uid.required && this.$v.user.uid.checkUidRegex1 && this.$v.user.uid.checkUidRegex2 && this.$v.user.uid.checkUidRegex3 && this.$v.user.uid.checkUidRegex4 && this.$v.user.uid.esiaCheck) {
					if (this.delayTimer) {
						clearTimeout(this.delayTimer)
					}
					var reg = this
					this.delayTimer = setTimeout(function() {
						reg.$store.dispatch(CHECK_UID, reg.user.uid)
						.then((data) => {				
							reg.uid.exist = data === true ? true : false
							resolve(true)
						})
					}, 1000)
				} else {
					this.uid.exist = false
					resolve(true)
				}
			})
		},
		validateUid() {
			const { $dirty, $error } = this.$v.user.uid
			return $dirty ? !$error : null
		},
		resetValidation() {
			this.$v.user.$reset()
		}
	}
}
</script>

<style lang="css" scoped>
.error {
	color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/views/Manager/Shared/BaseUid.vue